import { useMsal, useIsAuthenticated } from '@azure/msal-react';
import { Button } from './components/ui.js';
import { loginRequest } from './lib/authConfig.js';
import { BotBreakdown } from './views/BotBreakdown.js';
import { Header } from './views/Header.js';
import { HoneypotSparkline } from './views/HoneypotSparkline.js';
import { MetricsRow } from './views/MetricsRow.js';
import { PendingRewrites } from './views/PendingRewrites.js';
import { RecentSends } from './views/RecentSends.js';

function SignIn() {
  const { instance } = useMsal();
  return (
    <main className="max-w-content mx-auto px-6 py-24 flex items-center justify-center">
      <div
        className="rounded-lg border px-8 py-10 text-center space-y-4"
        style={{ borderColor: 'var(--border)', background: 'var(--bg-secondary)' }}
      >
        <h1 className="text-[18px] font-medium">AVL · Link filter</h1>
        <p className="text-[13px]" style={{ color: 'var(--text-secondary)' }}>
          Sign in with your Silver Falls Capital account to continue.
        </p>
        <Button
          variant="solid"
          size="md"
          onClick={() => {
            void instance.loginRedirect(loginRequest);
          }}
        >
          Sign in with Microsoft
        </Button>
      </div>
    </main>
  );
}

export function App() {
  const isAuthenticated = useIsAuthenticated();
  if (!isAuthenticated) return <SignIn />;

  return (
    <main className="max-w-content mx-auto px-6 pb-12">
      <Header />
      <div className="space-y-6">
        <MetricsRow />
        <PendingRewrites />
        <BotBreakdown />
        <RecentSends />
        <HoneypotSparkline />
      </div>
    </main>
  );
}
